import { mutatorAction } from 'satcheljs';
import { getProactiveDraftsStore } from '../store/store';
import { type ProactiveDraftCardState } from '../store/schema/ProactiveDraftCardState';

const setProactiveDraftListMutator: (
    itemId: string | undefined,
    proactiveDraftList: ProactiveDraftCardState[]
) => void = mutatorAction(
    'setProactiveDraftListMutator',
    function setProactiveDraftList(
        itemId: string | undefined,
        proactiveDraftList: ProactiveDraftCardState[]
    ): void {
        if (!itemId) {
            return;
        }

        const proactiveDraftsStore = getProactiveDraftsStore();
        if (proactiveDraftsStore.proactiveDraftsListMap.has(itemId)) {
            const proactiveDraftsState = proactiveDraftsStore.proactiveDraftsListMap.get(itemId);
            if (proactiveDraftsState) {
                proactiveDraftsState.proactiveDraftsList = proactiveDraftList;
            }
        }
    }
);
export default setProactiveDraftListMutator;
